import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import { ConfigProvider, App as AntdApp } from 'antd';
import locale from 'antd/es/locale/es_ES';

import reportWebVitals from './reportWebVitals';
import 'dayjs/locale/es';
import { App } from './App';
import store from './shared/store';
import { theme } from './config';

import { AuthProvider, InfoProvider, MasterProvider, UIProvider } from './shared/contexts';
import { OfflineBanner } from './shared/components/OfflineBanner';

import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <ConfigProvider theme={theme} locale={locale}>
      <AntdApp>
        <OfflineBanner />
        <AuthProvider>
          <InfoProvider>
            <MasterProvider>
              <UIProvider>
                <App />
              </UIProvider>
            </MasterProvider>
          </InfoProvider>
        </AuthProvider>
      </AntdApp>
    </ConfigProvider>
  </Provider>
);

reportWebVitals();

if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/sw.js`;
    navigator.serviceWorker.register(swUrl).catch(() => {});
  });
}
